/**
 * Derive the organisation BID from a spotlight BID (an entity / twin BID).
 *
 * The default rule is "first segment before the first dash":
 *   "TFN-WMZ-E035" → "TFN"
 *   "TFN-WMZ"     → "TFN"
 *   "TFN"         → "TFN"
 *
 * Newport Live is the sole exception. Its single twin uses the "NPL-STN"
 * prefix on every twin/entity BID, but the org BID is "NPLV2" — so the
 * default rule returns "NPL" which is not a real organisation. The hard-
 * coded exception below maps `NPL-STN` (and only that prefix, segment-
 * exact) back to "NPLV2".
 *
 * The exception is segment-exact (`bid === 'NPL-STN' || bid.startsWith('NPL-STN-')`)
 * so a future BID like `NPL-STN2-...` or `NPL-STNX-...` correctly falls
 * through to the default rule rather than being misrouted to NPLV2.
 *
 * Pure function: no side effects, no React, no stores. Surfaced by the
 * entity-flyto-links work; extracted into its own file so it can be reused
 * by other BID consumers without dragging the useSpotlight hook in.
 */
export function extractOrgBidFromSpotlightBid(bid: string | null | undefined): string | null {
  if (!bid) return null;

  // Newport Live exception. Segment-exact match to avoid the foot-gun where
  // a future BID happens to begin with the literal "NPL-STN".
  if (bid === 'NPL-STN' || bid.startsWith('NPL-STN-')) {
    return 'NPLV2';
  }

  const parts = bid.split('-');
  if (parts.length > 0 && parts[0]) {
    return parts[0];
  }
  return null;
}
